export default __webpack_public_path__ + "static/media/alliance.e8d02620.jpg";